"use client";

import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "@/app/_partials/_sections/_hooks/useSection";
import { frontendImage } from "@/lib/helpers";

import { useEffect, useState } from "react";
import PageSkeleton from "../skeleton/PageSkeleton";
import useCareer from "../_hooks/useCareer";
import CareerSection from "./CareerSection";

export default function Career() {
    const { pageTitle, trans } = useUtility();
    const { content: breadcrumb } = useSection("breadcrumb");
    const [activeCategory, setActiveCategory] = useState(0);
    const { jobs, categories, loading } = useCareer(activeCategory);

    useEffect(() => {
        pageTitle("Career");
    }, [pageTitle]);

    if (loading) {
        return <PageSkeleton />;
    }

    return (
        <>
            <section
                className="breadcrumb-banner-section bg-img"
                style={{
                    backgroundImage: `url(${frontendImage(
                        breadcrumb?.image,
                        "breadcrumb"
                    )})`,
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-banner text-center">
                                <h3 className="breadcrumb-banner__title mb-0">
                                    Our Careers
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CareerSection categories={categories} />
        </>
    );
}
